export const Pricing = {
  tier1Price: {
    low: 1200,
    high: 1500
  },
  tier2Price: {
    low: 12000,
    high: 15000
  },
  tier3Price: {
    low: 18000,
    high: 21000
  },
  numPhases: 3
};
